/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export type GssOccasionPersonTeaserConnectionDirection =
  (typeof GssOccasionPersonTeaserConnectionDirection)[keyof typeof GssOccasionPersonTeaserConnectionDirection];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GssOccasionPersonTeaserConnectionDirection = {
  pending_in: 'pending_in',
  pending_out: 'pending_out',
  accepted: 'accepted',
  none: 'none',
} as const;
